var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"foot"},[_c('van-button',{attrs:{"type":"default"},on:{"click":_vm.onBackHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('img',{attrs:{"src":require("@/assets/images/404.jpg")}})])
}]

export { render, staticRenderFns }